import Swal from "sweetalert2";
import {responses} from "@/services/responses";
import copy from 'copy-to-clipboard';
import Vue from "vue";

  //  window.ChickenLittle = `http://192.168.1.178:8080/ChickenLittle/`
 // window.ChickenLittle = `http://Musonda:8080/ChickenLittle/`

// window.KazangPaymentGateway = `http://192.168.1.124:8080/KazangPaymentGateway/V2/GateWay/`
// window.PaymentGateway = `http://192.168.1.124:8080/KazangPaymentGateway/`

    window.ChickenLittle = `https://lna.abc.co.zm/ChickenLittle/`

window.PaymentGateway = `https://lna.abc.co.zm/KazangPaymentGateway/`
window.franchiseTomcatApi = `https://overflow.abc.co.zm:8443/Franchise_OnlineServer/`
window.KazangPaymentGateway = `https://lna.abc.co.zm/KazangPaymentGateway/V2/GateWay/`

window.copy = copy;
window.responses = responses;
window.Swal = Swal;

import {utils} from "./utils";
window.$utils = utils;

import {dateTimeManager} from "./TimeManager";
window.$dateTimeManager = dateTimeManager;
Vue.prototype.$dateTimeManager = dateTimeManager;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}